import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  CardAction,
  CardComponent,
  CardContent,
  CardFilter,
  CardFooter,
  CardHeader,
  CardMenu,
  CardMenuFooter,
  CardMenuHeader,
  CardMenuItem,
  CardTitle
} from './card.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CardComponent, CardHeader, CardFooter, CardFilter, CardTitle, CardAction,
    CardMenu, CardContent, CardMenuHeader, CardMenuFooter, CardMenuItem
  ],
  exports: [
    CardComponent, CardHeader, CardFooter, CardFilter, CardTitle, CardAction,
    CardMenu, CardContent, CardMenuHeader, CardMenuFooter, CardMenuItem
  ]
})
export class CardModule { }



// WEBPACK FOOTER //
// /app/src/app/layout/card/card.module.ts